module.exports = function() {
  return new Worker(__webpack_public_path__ + "60d5e63f2c2d26852024.worker.js");
};